import { useMemo } from "react"

import { format } from "date-fns"

import { useShiftExceptions } from "@/hooks/useCollections"
import { sheriffBookingFor } from "@/lib/sheriffBooking"
import { Route } from "@/types/collections"

/**
 * Only while open and for the route's own day; shares the host's query because each call pages the
 * resourcing system.
 */
export function useSheriffBooking(route: Route | null, viewDate: Date | undefined, open: boolean) {
  const shiftDateStr = useMemo(
    () => (route ? format(viewDate ?? route.plannedStartTime, "yyyy-MM-dd") : undefined),
    [route, viewDate]
  )
  const { data: shiftCover } = useShiftExceptions(
    { from: shiftDateStr, to: shiftDateStr },
    open && !!route
  )
  return useMemo(
    () => (route ? sheriffBookingFor(route.id, shiftCover) : null),
    [route, shiftCover]
  )
}
